/* unplugin-vue-components disabled */import { render } from "./Payment.vue?vue&type=template&id=8c37bc06&scoped=true&ts=true"
import script from "./Payment.vue?vue&type=script&lang=ts"
export * from "./Payment.vue?vue&type=script&lang=ts"

import "./Payment.vue?vue&type=style&index=0&id=8c37bc06&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c37bc06"]])

export default __exports__